export default "__VITE_ASSET__Btc5hvJp__"